module.exports = __webpack_public_path__ + "img/lw-order-process-background-min.33d775f2.jpg";